import React from 'react';
import JobsRevenueUpload from './JobsRevenueUpload';

const RepairAnalysisUpload = () => (
  <JobsRevenueUpload
    title="Upload Repair Analysis"
    description="Upload the repair analysis CSV to upsert invoiced repair-analysis values in the jobs collection."
    endpoint="/api/v1/jobs/repair-analysis"
    successMessageText="Repair analysis uploaded successfully."
    errorMessageFallback="Failed to upload repair analysis."
    downloadFilePrefix="repair-analysis-results"
  />
);

export default RepairAnalysisUpload;
